import { useState, useEffect } from 'react';
import { raiseToast } from '@fiverr-private/toast';
import { translate } from '@fiverr-private/i18n-react';
import {
    SELLER_ID_QUERY_KEY,
    SELLER_NAME_QUERY_KEY,
    UPGRADE_SOURCE_QUERY_KEY,
    WAS_UPGRADED_QUERY_KEY,
} from '@fiverr-private/upsell';
import { useComplianceContext } from '../components';
import { ComplianceTypes } from '../components/ComplianceModal/types';

const usePaymentSuccessToast = () => {
    const [hasHandled, setHasHandled] = useState(false);
    const complianceContext = useComplianceContext();

    useEffect(() => {
        if (hasHandled) return;

        const url = new URL(window?.location?.href);
        const searchParams = url.searchParams;

        if (searchParams.has('upgradePlan')) {
            return;
        }

        const complianceType = searchParams.get('complianceSentType') as ComplianceTypes | null;
        if (!complianceType) return;

        const sellerId = Number(searchParams.get(SELLER_ID_QUERY_KEY));
        const sellerName = searchParams.get(SELLER_NAME_QUERY_KEY);

        if (complianceType === ComplianceTypes.LEGAL_DOCS) {
            raiseToast({
                location: 'top',
                type: 'success',
                message: translate(`compliance.toast.${complianceType}.success`),
            });
        } else {
            if (!complianceContext) return;
            complianceContext.openSuccessStep({
                sellerId,
                sellerName: sellerName ?? '',
                fromComplianceType: complianceType,
            });
        }

        [
            WAS_UPGRADED_QUERY_KEY,
            SELLER_ID_QUERY_KEY,
            SELLER_NAME_QUERY_KEY,
            UPGRADE_SOURCE_QUERY_KEY,
            'complianceSentType',
        ].forEach((key) => searchParams.delete(key));
        const newUrl = `${url.pathname}?${searchParams.toString()}`.replace(/\?$/, '');
        window?.history.replaceState(null, '', newUrl);

        setHasHandled(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasHandled, complianceContext]);
};

export default usePaymentSuccessToast;
